'use memo';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInvalidateUseGetAgencyInformationForUser } from '@urbanx/agx.agencies.client';
import { StoreAccessCodeResponseResult, useStoreAccessCode } from '@urbanx/agx.docusign.client';
import useQuery from 'hooks/useQuery';

const DocuSignAuthenticated = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const invalidateAgencyInformation = useInvalidateUseGetAgencyInformationForUser();
  const { storeAccessCode } = useStoreAccessCode({
    onSuccess: async (response) => {
      if (response?.result === StoreAccessCodeResponseResult.Success) {
        await invalidateAgencyInformation();
        navigate('/onboarding', { replace: true });
        return;
      }

      const errorCode =
        response?.result === StoreAccessCodeResponseResult.InvalidAccount
          ? 'invalid-account'
          : 'connection-failed';

      navigate(`/onboarding?docuSignErrorCode=${errorCode}`, { replace: true });
    },
    onError: () => navigate('/onboarding?docuSignErrorCode=connection-failed', { replace: true }),
  });

  useEffect(() => {
    const code = query.get('code');

    if (!code) {
      navigate('/onboarding?docuSignErrorCode=authorization-failed', { replace: true });
      return;
    }

    void storeAccessCode(code).catch(() => undefined);
  }, [navigate, query, storeAccessCode]);

  return null;
};

export default DocuSignAuthenticated;
